import React, { useRef, useEffect } from 'react';
import Vimeo from '@vimeo/player';

const VimeoPlayer = ({
  videoId, onVideoStart, onVideoEnded
}) => {
  const playerRef = useRef(null);
  const containerRef = useRef(null);

  let isPlayed = false;

  useEffect(() => {
    const containerWidth = containerRef.current.offsetWidth;

    const player = new Vimeo(playerRef.current, {
      id: videoId,
      autoplay: false,
      width: containerWidth,
      controls: true
    });

    player.on('play', () => {
      if (!isPlayed) {
        onVideoStart();
        isPlayed = true;
      }
    });
    player.on('ended', onVideoEnded);

    return () => {
      player.destroy();
    };
  }, [videoId]);

  return (
    <div ref={containerRef} style={{ width: '100%' }}>
      <div ref={playerRef} />
    </div>
  );
};

export default VimeoPlayer;
